import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './action';

let table = { ...config };
table.url = '/wms/receiving';
table.filter = {};
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 130,
    component: (row) => {
      return (
        <div className="text-ellipsis fw-semibold">{row?.code}</div>
      );
    },
  },

  receiving_plan: {
    title: 'Receiving Plan',
    sortable: false,
    width: 130,
    component: (row) => {
      return (
         <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.receiving_plan?.code}
          </div>
          <small className="info text-uppercase">
            {formatDate(row?.receiving_plan?.schedule_at)}
          </small>
        </div>
      );
    },
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')?.replace('voided', 'void')}
        </span>
      );
    },
  },

  created_by: {
    title: 'Dibuat Oleh',
    width: 60,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.created_by}
          </div>
          <small className="info text-uppercase">
            {formatDate(row?.created_at)}
          </small>
        </div>
      );
    },
  },

  received_by: {
    title: 'Diterima Oleh',
    width: 60,
    component: (row) => {
      return (
        row?.received_by !==  "" ? (
          <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.received_by}
          </div>
          <small className="info text-uppercase">
            {formatDate(row?.received_at)}
          </small>
        </div>
        ): (
          <span>-</span>
        )
      );
    },
  },

  action: {
    title: '',
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};
export default table;
